import { render, staticRenderFns } from "./ActionMealSwap.vue?vue&type=template&id=4b9adc98&scoped=true"
import script from "./ActionMealSwap.vue?vue&type=script&lang=js"
export * from "./ActionMealSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9adc98",
  null
  
)

export default component.exports